var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidbaricon5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9618 11.2234C13.5243 8.5909 12.1621 6.63059 10.978 5.47917C10.6334 5.14412 10.4611 4.97659 10.0805 4.82155C9.69993 4.6665 9.3728 4.6665 8.71853 4.6665H7.28147C6.62721 4.6665 6.30007 4.6665 5.91948 4.82155C5.53889 4.97659 5.36661 5.14412 5.02203 5.47917C3.83788 6.63059 2.47574 8.5909 2.03818 11.2234C1.71262 13.1821 3.51951 14.6665 5.53888 14.6665H10.4611C12.4805 14.6665 14.2874 13.1821 13.9618 11.2234Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.83758 2.96208C4.70004 2.76188 4.50069 2.49016 4.9125 2.4282C5.33578 2.3645 5.77531 2.65426 6.20554 2.6483C6.59475 2.64292 6.79304 2.47029 7.00577 2.22382C7.22977 1.96428 7.57664 1.3335 7.99984 1.3335C8.42304 1.3335 8.7699 1.96428 8.9939 2.22382C9.20664 2.47029 9.4049 2.64292 9.7941 2.6483C10.2244 2.65426 10.6639 2.3645 11.0872 2.4282C11.499 2.49016 11.2996 2.76188 11.1621 2.96208L10.5402 3.86726C10.2742 4.25447 10.1412 4.44808 9.86277 4.55746C9.58444 4.66683 9.2247 4.66683 8.5053 4.66683H7.49437C6.77497 4.66683 6.41524 4.66683 6.13688 4.55746C5.85852 4.44808 5.7255 4.25447 5.45947 3.86726L4.83758 2.96208Z",
    stroke: "white",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.08463 8.61255C8.9405 8.08048 8.2069 7.60035 7.3263 7.95955C6.44569 8.31868 6.30581 9.47435 7.63783 9.59715C8.23983 9.65261 8.63236 9.53275 8.9917 9.87188C9.3511 10.2109 9.41783 11.154 8.49916 11.4081C7.5805 11.6623 6.67083 11.2652 6.57178 10.7013M7.89463 7.32861V7.83555M7.89463 11.4863V11.9953",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidbaricon5);
export default __webpack_public_path__ + "static/media/sidbaricon5.0c3de1cfc73239c5d63571c606c9ed09.svg";
export { ForwardRef as ReactComponent };